import { defineAction } from '~/prix'
import systemProcessDatasetsAction from './systemProcessDatasets.action.json' with { type: 'json' }
import { z } from 'zod'
import { datasets } from '../bulk/systemBulk.data'

const datasetName = z.string().refine(value => Object.hasOwn(datasets, value), {
  message: 'Dataset não registrado',
})

const systemProcessDatasetsDefinition = defineAction({
  ...systemProcessDatasetsAction,

  input: z.object({
    dataSourceIds: z.array(z.number().int().positive()).optional(),
    datasetNames: z.array(datasetName).optional(),
  }),
  output: z.object({
    ok: z.boolean(),
  }),
})

export default systemProcessDatasetsDefinition
